import * as React from "react";
import Chart from "react-apexcharts";
import Cookies from "universal-cookie";
import "./barGraph.css";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logger } from "../../../Logger/Logger";

const BarGraph = ({ asd }) => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  let arr = [];
  const [countBySeverity, setCountBySeverity] = useState("");
  const [barData, setBarData] = useState([]);
  const [stOpen, setStOpen] = useState([]);
  const [stClose, setStClose] = useState([]);
  const [isUnd, setIsUnd] = useState(false);
  const [count, setCount] = useState(0);
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  const date = new Date();
  let year = date.getFullYear();

  Logger.debug("apiKey", apiKey, "\n......asd", asd);
  const queryParams = {
    year: new Date().getFullYear(),
  };

  const params = new URLSearchParams(queryParams);

  const yearlyData = () => {
    axios
      .get(`${BASE_URL}api/dashboard/monthly_ticket_count_by_year/?${params}`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("bar graph data", typeof res.data.data);
        setBarData(res.data.data);
      })
      .catch((error) => {
        Logger.error("error in bar graph data", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };
  Logger.debug("barData....", barData);

  const dataAvail = () => {
    Object.keys(barData).forEach(function (key, index) {
      if (barData[key].Open > 0 || barData[key].Closed > 0) {
        setIsUnd(true);
      }
    });
    setOpenCloseData();
  };

  const setOpenCloseData = () => {
    for (let i in barData) {
      Logger.debug(i, "In for>>>>>>", barData[i].Open);
      if (stOpen.length < 12) {
        stOpen.push(barData[i]?.Open);
      }
      if (stClose.length < 12) {
        stClose.push(barData[i]?.Closed);
      }
    }
  };

  useEffect(() => {
    dataAvail();
  }, [barData]);
  useEffect(() => {
    yearlyData();
  }, [asd]);

  Logger.debug("stopen>>>>>>>>.", stOpen);
  return (
    <div className="barcontainer">
      {isUnd ? (
        <Chart
          type="bar"
          width={"100%"}
          height={"200px"}
          series={[
            {
              name: "Open",
              data: stOpen,
            },
            {
              name: "Closed",
              data: stClose,
            },
          ]}
          options={{
            // title:{
            //     text:'Sample Bar Graph',
            //     style:{fontSize:30}
            // },
            colors: ["rgb(0, 143, 251)", "rgb(255, 69, 96)", "#2D033B"],
            theme: { mode: "light" },
            xaxis: {
              categories: [
                "Jan-23",
                "Feb-23",
                "Mar-23",
                "Apr-23",
                "May-23",
                "Jun-23",
                "Jul-23",
                "Aug-23",
                "Sep-23",
                "Oct-23",
                "Nov-23",
                "Dec-23",
              ],
            },
            legend: {
              display: true,
              position: "right",
            },
          }}
        ></Chart>
      ) : (
        <h1>No records to display</h1>
      )}
    </div>
  );
};
export default BarGraph;
